import { connect } from 'react-redux';
import FilterPopover from './FilterPopover';
import { setFilters } from '../../filters/store/filtersSlice';

const mapState = state => ({
  activeSelfAuthTab: state.loadingManagement.selfAuthorizations.activeSelfAuthTab,
  authorizationSelection: state.loadingManagement.filters.authorizationSelection,
  extendedLoadingSelection: state.loadingManagement.filters.extendedLoadingSelection,
});

export default connect(mapState, { setFilters })(FilterPopover);
